<template>
  <div class="el-card container-view">
    <row-grid :span="[6, 18]">
        <template #0>
            <tree :meta="treeMeta" @active-change="handleActiveChange" @chose-change="handleChoseChange"></tree>
        </template>
        <template #1>
            <form-view :ref="formRefName" :meta="formMeta">
                <template #action="{model, conf}">
                    <slot name="action" v-bind:model="model" v-bind:conf="conf"></slot>
                </template>
            </form-view>
        </template>
    </row-grid>
  </div>
</template>

<script>
    import utils from '../utils'
    import {restUrl} from '../constant/url'
    import {defaultPrimaryKey} from "../config";
    import {getTreeMeta, loadFeature} from '../utils/rest'
    import DefaultFormViewMeta from '../core/formview/ui-conf'

    export default {
        name: "TreeFormTmpl",
        meta: {
          isTemplate: true,
          isPage: false,
          cn: '左树-右表单模板',
          icon: 'tree_form',
          buildIn: true // 内建：DbMeta提供
        },
        props: {
            fc: String,
            oc: String
        },
        data() {
            const {fc: R_fc, oc: R_oc} = this.$route.query;
            const featureCode = utils.assertUndefined(this.fc, R_fc);
            const objectCode = utils.assertUndefined(this.oc, R_oc);

            return {
                treeConf: {},
                formConf: {},
                treeMeta: {},
                formMeta: {},
                featureCode: featureCode,
                objectCode: objectCode
            }
        },
        methods: {
            handleChoseChange(rows) {
                // pxg_todo 树多选的默认行为
            },
            handleActiveChange(row) {
                if (utils.isEmpty(row)) {
                    this.formMeta = this.$merge({}, DefaultFormViewMeta);
                    return;
                }
                const primaryKey = this.primaryKey;
                const primaryValue = utils.extractValue(row, primaryKey);
                const objectCode = this.treeMeta['objectCode'];

                let url = this.$compile(restUrl.RECORD_TO_UPDATE, {
                    objectCode: objectCode,
                    primaryKv: primaryValue
                });
                this.$axios.get(url).then(resp => {
                    this.formMeta = resp.data;
                });
            },
            initMeta(objectCode) {
                getTreeMeta(this.$axios, objectCode).then(resp => {
                    this.treeMeta = resp.data;
                }).catch(({msg = '获取Tree meta数据错误'}) => {
                    console.error('[ERROR] msg: %s', msg);
                });
            }
        },
        created() {
            const {featureCode, objectCode} = this;
            if (!utils.isEmpty(featureCode)) {
                loadFeature(this.$axios, this.featureCode).then(resp => {
                    const feature = resp.data;
                    this.treeConf = feature['tree'];
                    this.formConf = feature['form'];

                    const {objectCode: treeObjectCode} = this.treeConf;
                    this.initMeta(treeObjectCode);
                });
            } else {
                this.initMeta(objectCode);
            }
        },
        computed: {
            formRefName() {
                return this.formMeta['name'];
            },
            primaryKey() {
                let primaryKey = this.treeMeta.hasOwnProperty('objectPrimaryKey') ? this.treeMeta['objectPrimaryKey'] : defaultPrimaryKey;
                return primaryKey.split(',');
            }
        }

    }
</script>

<style scoped>

</style>
